import jwt from '../../http/requests/auth/jwt/index.js'

import router from '@/router'

export default {
    loginAttempt({dispatch}, payload) {

        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            closeAnimation: payload.closeAnimation
        }
    },
    login({commit, state, dispatch}, payload) {

        // If user is already logged in notify and exit
        if (state.isUserLoggedIn()) {
            // Close animation if passed as payload
            if (payload.closeAnimation) payload.closeAnimation()

            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })

            return false
        }
    },


    updateUsername({commit}, payload) {
        payload.user.updateProfile({
            displayName: payload.displayName
        }).then(() => {

            // If username update is success
            // update in localstorage
            const newUserData = Object.assign({}, payload.user.providerData[0])
            newUserData.displayName = payload.displayName
            commit('UPDATE_USER_INFO', newUserData, {root: true})

            // If reload is required to get fresh data after update
            // Reload current page
            if (payload.isReloadRequired) {
                // router.push(router.currentRoute.query.to || '/')
            }
        }).catch((err) => {
            payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
    },


    // JWT
    loginJWT({commit}, payload) {
        return new Promise((resolve, reject) => {
            jwt.login(payload.userDetails.email, payload.userDetails.password)
                .then(response => {
                    // If there's user data in response
                    if (response.data.token) {

                        // Set accessToken
                        localStorage.setItem('accessToken', response.data.token)

                        // Update user details
                        let base64Payload = response.data.token.split('.')[1];
                        let payload = Buffer.from(base64Payload, 'base64');
                        let userData = JSON.parse(payload);
                        let r = '';
                        if (userData.role == 'Διαχειριστής') {
                            r = 'admin';
                        } else {
                            r = 'editor';
                        }
                        let userInfo = {
                            'displayName': userData.name + " " + userData.surname,
                            'uid': userData.id,
                            'userRole': r
                        };
                        commit('UPDATE_USER_INFO', userInfo, {root: true})

                        // Set bearer token in axios
                        commit('SET_BEARER', response.data.token)
                        // Navigate User to homepage
                        router.push(router.currentRoute.query.to || '/')
                        resolve(response)
                    } else {
                        reject({message: 'Wrong Email or Password'})
                    }

                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    registerUserJWT({commit}, payload) {

        const {displayName, email, password, confirmPassword} = payload.userDetails

        return new Promise((resolve, reject) => {

            // Check confirm password
            if (password !== confirmPassword) {
                reject({message: 'Password doesn\'t match. Please try again.'})
            }

            jwt.registerUser(displayName, email, password)
                .then(response => {
                    // Redirect User
                    router.push(router.currentRoute.query.to || '/')

                    // Update data in localStorage
                    localStorage.setItem('accessToken', response.data.accessToken)
                    commit('UPDATE_USER_INFO', response.data.userData, {root: true})

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    fetchAccessToken() {
        return new Promise((resolve) => {
            jwt.refreshToken().then(response => {
                resolve(response)
            })
        })
    }
}
